module.exports = __webpack_public_path__ + "static/MMI-f33d463aac4b9d6664927017380376ca.png";